// Types
import { DATA_EXPORT_VERSION } from '@src/constants/version';
import type { RootState } from '@src/store/index';
import { selectBizSkill } from '@src/store/slices/biz_skills';
import { selectPrivateActivity } from '@src/store/slices/private_activity';
import { selectSkill } from '@src/store/slices/skill';
import type { GeneratePdfApiParams } from '@src/types/shared/api/pdf_api_params';

export default function getRequestParams(s: RootState): GeneratePdfApiParams {
  const params: GeneratePdfApiParams = {
    version: DATA_EXPORT_VERSION,
    contact: s.resumeContact,
    skillType: s.skillType.type,
    skillsComment: s.skillComment.content,
    bizSkills: selectBizSkill(s),
    skills: selectSkill(s),
    history: s.resumeHistory.histories,
    project: s.project.projects,
    careerSummary: s.careerSummary.content,
    nextCareer: s.nextCareer.content,
    otherActivity: selectPrivateActivity(s),
    educationalBackground: s.educationalBackground,
    isBlind: s.ui.blind,
  };

  return params;
}
